export const UNAUTH_USER = 'unauth_user';

export function unauthUser() {
  console.log("unauthorized");
	return {
		type: UNAUTH_USER,
		payload: null
	
  };

}


// WEBPACK FOOTER //
// ./src/redux/actions/errorsActions.js